import { observer } from 'mobx-react-lite'

import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import ToggleButton from 'common/ToggleButton/ToggleButton'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useTogglePostApproval } from 'hooks/useTogglePostApproval'

import Styles from './ApprovalsSettings.module.scss'

export const ApprovalsSettings = observer(() => {
  const workspace = useCurrentWorkspace()
  const togglePostApproval = useTogglePostApproval()

  if (!workspace?.is_virtual_marketer) return null

  const listItems = [
    'Nothing posts without your approval',
    'Easily make quick revisions',
    'Move content to Draft to revisit later',
  ]
  const isToggledChecked = !!workspace.post_approval_enabled

  return (
    <div className={Styles.section}>
      <div className={Styles.headerRow}>
        <div className={Styles.headerContent}>
          <Heading level={3}>Approvals</Heading>
          <Text variant="secondary" color="var(--dark-60)" className={Styles.description}>
            Require your review on all of your content before it automatically publishes
          </Text>
          {!isToggledChecked && (
            <ul className={Styles.bulletList}>
              {listItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )}
        </div>
        <div className={Styles.toggleRow}>
          <ToggleButton
            checked={isToggledChecked}
            name="approvals-toggle"
            handleChange={togglePostApproval}
            size="sm-md"
          />
        </div>
      </div>
    </div>
  )
})
